export const state = {
  retryAt: null,
  maintenanceModeEnabled: false,
  statusPending: false,
  statusError: null,
}
